var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialBreakdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.51 12.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-width:.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14988",
    className: "cls-1",
    d: "m.25.48v11.28h6.55l-1.32-3.38-1.76-1.29-1.33-2.63-.42-2.76L.25.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14989",
    className: "cls-1",
    d: "m.25,5.57l1.54.71.82,1.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14990",
    className: "cls-1",
    d: "m1.41,10.39l.91-.9h1.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14992",
    className: "cls-1",
    d: "m5.73,6.63l1.08,1.13h.55v-1.13l-1.07-.51-.56.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15231",
    className: "cls-1",
    d: "m9.51,8.78l-1.57,1.49v.77h1.57l.7-1.49-.7-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14993",
    className: "cls-1",
    d: "m4.6,3.28l1.47.69-1.47.81-.67-.81.67-.69Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialBreakdown);
export default __webpack_public_path__ + "static/media/material_breakdown.f54f552b6898359905d506f58ccf4a63.svg";
export { ForwardRef as ReactComponent };